import formComposeExperience from './formComposeExperience';
import formComposeExperienceDetail from './formComposeExperienceDetail';
import { updateForm } from '../store/actions/camerasPresentationAction';
import formComposeExperienceTagging from './formComposeExperienceTagging';

export default {
  title: 'New Media',
  attributeName: 'composeExperience',
  getURL: 'composeExperience',
  idAttribute: 'id',
  saveIdSessionNameAs: 'composeExperienceId',
  createURL: '',
  updateURL: 'composeExperience',
  removeURL: 'composeExperienceUrl',
  customAction: updateForm,
  noArea: true,
  sessionParams: [],
  formConfig: [formComposeExperience, formComposeExperienceDetail,formComposeExperienceTagging],
  goBack: true,
  autoUpdate: false,
  idUpdate:true
  // websocketNavigation:'users_navigation',

};